export const getPlaceholderImageUrl = (imageUrl, width, height) => {
  const filters = `e_blur:1000,w_${width},h_${height},f_webp,q_auto`

  return `${process.env.NEXT_PUBLIC_CLOUDINARY_PREFIX}/image/fetch/${filters}/${imageUrl}`
}
